import {NavLink, useNavigate} from "react-router-dom";
import {Ajax} from "../Service/ajax";
import React, {useEffect, useMemo, useState} from "react";
import Swal from "sweetalert2";
import Modal from "./Modal";
import {ClipLoader} from "react-spinners";
export default function Table({ title, type, content: content = [], setResource, devise, setDevise, transactionType, setTransactionType, reference,setReference, charging, currentPage, setCurrentPage, isLastPage}) {
    const sanitizedContent = useMemo(() => content || [], [content]);// sécurité supplémentaire au cas où "content" est explicitement passé comme null
    const [subscriptionsPlan, setSubscriptionsPlan] = useState(sanitizedContent);
    const [informations, setInformations] = useState(sanitizedContent);
    const [options, setOptions] = useState(sanitizedContent);
    const [transactions, setTransactions] = useState(sanitizedContent);
    const isEmpty = sanitizedContent.length === 0;
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const [updating, setUpdating] = useState(false);
    const [consultingId, setConsultingId] = useState(null);
    const [refValue, setRefValue] = useState(reference);
    const company = JSON.parse(sessionStorage.getItem("company"));

    // const [currentPage, setCurrentPage] = useState(1);
    // const [isLastPage, setIsLastPage] = useState(false);

    const [searchValue, setSearchValue] = useState("");


    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const handleNextPage = () => {
        if (!isLastPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };


    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    useEffect(() => {
        setTransactions(sanitizedContent);
    }, [sanitizedContent, currentPage, isLastPage]);

    const handleInputChangeTrs = (e) => {
        const value = e.target.value;
        setRefValue(value);

        if (value.trim() === "") {
            setReference("all");
        } else {
            setReference(value);
        }
    };

    const filteredContent = sanitizedContent.filter(item =>
        item.fullNumber && item.fullNumber.includes(searchValue)
    );



    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showModal, setShowModal] = useState(false);


    const openModal = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedPlan(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectedPlan(prev => ({ ...prev, [name]: value }));
    };

    const handleShowDetails = async (plan) => {
        try {
            setConsultingId(plan.id);
            const {data} = await Ajax.getRequest(`/api/v1/sub/subscription/show-details/${plan.id}`);
            if (data.error) {
                Swal.fire({
                    title: 'Error!',
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                    }
                })
            }else{
                Swal.fire({
                    title: `Informations`,
                    html: data.object.length > 0
                        ? `<div style="text-align: left">
                             ${data.object.map(item => `<p><strong>${item.title} :</strong> ${item.value}</p>`).join('')}
                            </div>`
                        : `<div style="text-align: center">Aucune information</div>`,
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                });
            }
        } catch (e) {
            Swal.fire({
                title: 'Error!',
                text: e.message,
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                }
            })
        }finally {
            setConsultingId(null);

        }
    }

    const handleValueChange = (index, newValue) => {
        setSelectedPlan(prev => {
            const updatedValues = [...prev.options];
            updatedValues[index].value = newValue;
            return { ...prev, options: updatedValues };
        });
    };

    const handleToggleValue = (index) => {
        setSelectedPlan(prev => {
            const updatedValues = prev.options.filter((_, i) => i !== index);
            return { ...prev, options: updatedValues };
        });
    };

    const updateSubscription = async (sub) => {
        let subscription = {
            planId: sub.id,
            name: sub.name,
            price: sub.price,
        }
        setUpdating(true);
        try {
            const {data} = await Ajax.putRequest("/api/v1/sub/subscription-plan/update", subscription);
            if (data.error) {
                Swal.fire({
                    title: 'Error!',
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000 // Fermer l'alerte après 5 secondes
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                        window.location.reload();
                    }
                });
            }else{
                Swal.fire({
                    title: 'Success!',
                    text: data.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000 // Fermer l'alerte après 5 secondes
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                        window.location.reload();
                    }
                });
            }
        }catch (e){
            Swal.fire({
                title: 'Error!',
                text: e.message,
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000 // Fermer l'alerte après 5 secondes
            }).then((result) => {
                if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                    window.location.reload();
                }
            });
        }finally {
            setUpdating(false);
            closeModal();
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        updateSubscription(selectedPlan);
    };


    let componentToRender;
    const application=JSON.parse(sessionStorage.getItem("application"));
    async function removeResource(tag, dataType, resource) {
        if (!session) {
            window.location.replace(window.location.origin);
        } else {
            const sendData = {
                tag: tag,
                dataType: dataType
            };
            try {
                const { data } = await Ajax.putRequest(`/api/v1/sub/application/${application.id}/${resource}/remove`, sendData);
                if (data.error) {
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000 // Fermer l'alerte après 5 secondes
                    });
                } else {
                    // Afficher la popup de succès
                    Swal.fire({
                        title: 'Success!',
                        text: 'suppression réussie avec succès',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000 // Fermer l'alerte après 5 secondes
                    });
                    // Mise à jour de l'état en fonction du type de ressource
                    if (resource === 'options') {
                        setOptions(prevOptions =>
                            prevOptions.filter(option => option.title !== tag)
                        );
                    } else if (resource === 'informations') {
                        setInformations(prevInformations =>
                            prevInformations.filter(info => info.tag !== tag)
                        );
                    }
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }
        }
    }
    async function changeStatus(status, id){
        if (!session) {
            window.location.replace(window.location.origin);
        } else {
            try {
                const {data} = await Ajax.putRequest(`/api/v1/sub/application/${application.id}/subscription/${id}/status/${status}`);
                if (data.error) {
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000 // Fermer l'alerte après 5 secondes
                    });
                } else {
                    // Mise à jour du statut dans la table
                    setSubscriptionsPlan(prevSubscriptionsPlan =>
                        prevSubscriptionsPlan.map(subscriptionPlan =>
                            subscriptionPlan.id === id ? { ...subscriptionPlan, status: status } : subscriptionPlan
                        )
                    );
                    // Afficher la popup de succès
                    Swal.fire({
                        title: 'Success!',
                        text: 'Modification sur le pack d\'abonnement effectuée avec succès',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000 // Fermer l'alerte après 5 secondes
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }
        }
    }
    function removeInformation(tag, dataType, infos, setInfo) {
        const indexToRemove = infos.findIndex(info => info.tag === tag && info.dataType === dataType);
        if (indexToRemove !== -1) {
            const updatedList = infos.filter((_, index) => index !== indexToRemove);
            setInfo(updatedList);
        }
    }
    function removeOption(title, dataType, options, setOptions) {
        const indexToRemove = options.findIndex(option => option.title === title && option.dataType === dataType);
        if (indexToRemove !== -1) {
            const updatedList = options.filter((_, index) => index !== indexToRemove);
            setOptions(updatedList);
        }
    }


    if (type === 'app') {
        componentToRender = isEmpty ? (
            <p className="text-center">Aucune application disponible</p>
        ) : (
            <table className="table table-hover mb-5">
                <thead>
                <tr>
                    <th>Nom</th>
                    <th>Date de création</th>
                    <th>Date de validation</th>
                    <th>Access id</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                {sanitizedContent.map((item, index) => (
                    <tr key={index}>
                        <td>{item["Nom"]}</td>
                        <td>{item["Date creation"]}</td>
                        <td>{item["Date validation"]}</td>
                        <td>{item["Access_id"]}</td>
                        <td>
                            {item["Status"] === 'REQUESTED' && (
                                <>
                                    <span className="badge bg-label-info">{item["Status"]}</span>
                                </>
                            )}
                            {item["Status"] === 'APPROVED' && (
                                <>
                                    <span className="badge bg-label-success">{item["Status"]}</span>
                                </>
                            )}
                            {item["Status"] === 'DISAPPROVED' && (
                                <>
                                    <span className="badge bg-label-warning">{item["Status"]}</span>
                                </>
                            )}
                            {item["Status"] === 'DISABLED' && (
                                <>
                                    <span className="badge bg-label-danger">{item["Status"]}</span>
                                </>
                            )}
                            {item["Status"] === 'N/D' && (
                                <>
                                    <span className="badge bg-label-danger">{item["Status"]}</span>
                                </>
                            )}
                        </td>
                        {sanitizedContent.length > 0 ? <td>
                            <div className="dropdown">
                                <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                        data-bs-toggle="dropdown">
                                    <i className="bx bx-dots-vertical-rounded"></i>
                                </button>
                                <div className="dropdown-menu">
                                    {item["Status"] === 'REQUESTED' && (
                                        <>
                                            <button className="dropdown-item">
                                                <i className="bx bx-trash me-1"></i> Approuver
                                            </button>
                                            <button className="dropdown-item">
                                                <i className="bx bx-trash me-1"></i> Désapprouver
                                            </button>
                                        </>
                                    )}
                                    {item["Status"] === 'APPROVED' && (
                                        <NavLink to={"/application"} className="dropdown-item">
                                            <i className="bx bx-edit-alt me-1"></i> Modifier
                                        </NavLink>
                                    )}
                                    {item["Status"] === 'DISAPPROVED' && (
                                        <button className="dropdown-item">
                                            <i className="bx bx-trash me-1"></i> Réapprouver
                                        </button>
                                    )}
                                    {item["Status"] === 'DISABLED' && (
                                        <button className="dropdown-item">
                                            <i className="bx bx-trash me-1"></i> Réapprouver
                                        </button>
                                    )}
                                </div>
                            </div>
                        </td> : ""}
                    </tr>
                ))}
                </tbody>
            </table>
        );
    } else {
        switch (type) {
            case 'infos':
                componentToRender = isEmpty ? (
                    <p className="text-center">Aucune information disponible</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Type de donnees</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {informations.map((item, index) => (
                            <tr key={index}>
                                <td>{item.tag}</td>
                                <td>{item.dataType}</td>
                                {informations.length > 0 ? <td> 
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            {item.tag !== 'N/D' && (
                                                <>
                                                    <button className="dropdown-item" onClick={
                                                        () =>{
                                                            removeResource(item.tag,item.dataType,"informations")
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Supprimer
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td> : ""}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'infosMini':
                componentToRender = isEmpty ? (
                    <p className="text-center">Aucune information ajoutée</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Type de donnees</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {sanitizedContent.map((item, index) => (
                            <tr key={index}>
                                <td>{item.tag}</td>
                                <td>{item.dataType}</td>
                                {sanitizedContent.length > 0 ? <td>
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            {item.tag !== 'N/D' && (
                                                <>
                                                    <button className="dropdown-item" onClick={
                                                        () =>{
                                                            removeInformation(item.tag,item.dataType, sanitizedContent, setResource)
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Supprimer
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td> : ""}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'options':
                componentToRender = isEmpty ? (
                    <p className="text-center">Aucune option disponible</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Type de donnees</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {options.map((item, index) => (
                            <tr key={index}>
                                <td>{item.title}</td>
                                <td>{item.dataType}</td>
                                {options.length > 0 ? <td> 
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            {item.title !== 'N/D' && (
                                                <>
                                                    <button className="dropdown-item" onClick={
                                                        () =>{
                                                            removeResource(item.title,item.dataType,"options")
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Supprimer
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td> : ""}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'optionsMini':
                componentToRender = isEmpty ? (
                    <p className="text-center">Aucune option ajoutée</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Type de donnees</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {sanitizedContent.map((item, index) => (
                            <tr key={index}>
                                <td>{item.title}</td>
                                <td>{item.dataType}</td>
                                {sanitizedContent.length > 0 ? <td>
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            {item.title !== 'N/D' && (
                                                <>
                                                    <button className="dropdown-item" onClick={
                                                        () =>{
                                                            removeOption(item.title,item.dataType, sanitizedContent, setResource)
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Supprimer
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td> : ""}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'clientSubscription':
                componentToRender = isEmpty || filteredContent.length === 0 ? (
                    <p className="text-center">{filteredContent.length === 0 ? "Aucun résultat trouvé." : "Aucun abonnement disponible" }</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Client</th>
                            <th>Abonnement</th>
                            <th>Prix</th>
                            <th>Periodicité</th>
                            <th>Date souscription</th>
                            <th>Date expiration</th>
                            <th>Status</th>
                            <th>Details</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {filteredContent.map((item, index) => (
                            <tr key={index}>
                                <td>{item.fullNumber}</td>
                                <td>{item.subscription}</td>
                                <td>{item.price}</td>
                                <td>{item.periodicity}</td>
                                <td>{item.start_time}</td>
                                <td>{item.end_time}</td>
                                <td>
                                    {item.status === 'ACTIVE' && (
                                        <>
                                            <span className="badge bg-label-success">{item.status}</span>
                                        </>
                                    )}
                                    {item.status === 'EXPIRED' && (
                                        <>
                                            <span className="badge bg-label-warning">{item.status}</span>
                                        </>
                                    )}
                                    {item.status === 'CANCELED' && (
                                        <>
                                            <span className="badge bg-label-danger">{item.status}</span>
                                        </>
                                    )}
                                    {item.status === 'N/D' && (
                                        <>
                                            <span className="badge bg-label-danger">{item.status}</span>
                                        </>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-outline-netikash ms-2"
                                        title="Voir Détails"
                                        onClick={() => handleShowDetails(item)}
                                    >
                                        {consultingId === item.id ? (
                                            <ClipLoader color="#36d7b7" loading size={20} />
                                        ) : (
                                            <i className="bx bx-show"></i>
                                        )}
                                    </button>
                                </td>

                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'transactions':
                componentToRender = isEmpty ? (
                    <p className="text-center">{transactionType === "PMT" ? "La liste de paiement est vide" : "La liste des retrait est vide"}</p>
                ) : (
                    <table className="table table-hover mb-5">
                        <thead>
                        <tr>
                            <th>Reference</th>
                            <th>Operation</th>
                            <th>Amount</th>
                            {transactionType === "WDL" && <th>Compte</th>}
                            {transactionType === "WDL" && <th>Numero</th>}
                            {transactionType === "PMT" && <th>Net Amount</th>}
                            <th>Date</th>
                            <th>Heure</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                        {transactions.map((item, index) => (
                            <tr key={index}>
                                <td>{item.ref}</td>
                                <td>{item.operation}</td>
                                <td>{item.currency}{item.amount}</td>
                                {transactionType === "WDL" && <td>{item.provider_name}</td>}
                                {transactionType === "WDL" && <td>{item.maker}</td>}
                                {transactionType === "PMT" && <td>{item.currency}{item.netAmount}</td>}
                                <td>{new Date(item.state.requested_at).toLocaleDateString()}</td>
                                <td>{new Date(item.state.requested_at).toLocaleTimeString()}</td>
                                <td>
                                    {item.status === 'requested' && (
                                        <span className="badge bg-label-warning " style={{ textTransform: 'none' }}>Demandé</span>
                                    )}

                                    {item.status === 'approved' && (
                                        <span className="badge bg-label-primary " style={{ textTransform: 'none' }}>Approuvé</span>
                                    )}

                                    {item.status === 'completed' && (
                                        <span className="badge bg-label-success " style={{ textTransform: 'none' }}>Terminé</span>
                                    )}

                                    {item.status === 'rejected' && (
                                        <span className="badge bg-label-danger " style={{ textTransform: 'none' }}>Rejeté</span>
                                    )}

                                    {item.status === 'failed' && (
                                        <span className="badge bg-label-danger " style={{ textTransform: 'none' }}>Échoué</span>
                                    )}

                                    {item.status === 'expired' && (
                                        <span className="badge bg-label-secondary " style={{ textTransform: 'none' }}>Expiré</span>
                                    )}

                                </td>
                                <td>
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            {item.status === 'requested' && (
                                                <>
                                                    <button className="dropdown-item" onClick={
                                                        () =>{
                                                            let presence="tabs"
                                                            navigate("/withdrawal-confirmation",{ state: { company, presence } })
                                                        }
                                                    }>
                                                        <i className="bx bx-card me-1"></i> Confirmer
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td>

                            </tr>
                        ))}
                        </tbody>
                    </table>
                );
                break;
            case 'subscriptionPlan':
                componentToRender = isEmpty ? (
                    <p className="text-center">Aucun plan d'abonnement disponible</p>
                ) : (
                    <>
                        <table className="table table-hover mb-5">
                            <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Nombre information</th>
                                <th>Nombre option</th>
                                <th>Prix</th>
                                <th>Periodicite</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody className="table-border-bottom-0">
                            {subscriptionsPlan.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.infos.length}</td>
                                    <td>{item.options.length}</td>
                                    <td>{item.currency+""+item.price}</td>
                                    <td>{item.periodicity}</td>
                                    <td>
                                        {item.status === 'ACTIVE' && (
                                            <>
                                                <span className="badge bg-label-info">{item.status}</span>
                                            </>
                                        )}
                                        {item.status === 'DISABLED' && (
                                            <>
                                                <span className="badge bg-label-danger">{item.status}</span>
                                            </>
                                        )}
                                    </td>
                                    {subscriptionsPlan.length > 0 ? <td> 
                                        <div className="dropdown">
                                            <button type="button" className="btn p-0 dropdown-toggle hide-arrow"
                                                    data-bs-toggle="dropdown">
                                                <i className="bx bx-dots-vertical-rounded"></i>
                                            </button>
                                            <div className="dropdown-menu">
                                                {item.status === 'ACTIVE' && (
                                                    <button className="dropdown-item" onClick={
                                                        () => {
                                                            changeStatus('DISABLED', item.id)
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Désactiver
                                                    </button>
                                                )}
                                                {item.status === 'DISABLED' && (
                                                    <button className="dropdown-item" onClick={
                                                        () => {
                                                            changeStatus('ACTIVE', item.id)
                                                        }
                                                    }>
                                                        <i className="bx bx-trash me-1"></i> Activer
                                                    </button>
                                                )}
                                                <button className="dropdown-item" onClick={() => openModal(item)}>Modifier</button>
                                            </div>
                                        </div>
                                    </td> : ""}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        {showModal && selectedPlan && (
                            <div className="modal show d-block" tabIndex="-1">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Modifier l'abonnement</h5>
                                            <button type="button" className="btn-close" onClick={closeModal}></button>
                                        </div>
                                        <div className="modal-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3">
                                                    <label className="form-label">Nom</label>
                                                    <input type="text" className="form-control" name="name" value={selectedPlan.name} onChange={handleChange} required />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Prix</label>
                                                    <input type="number" className="form-control" name="price" value={selectedPlan.price} onChange={handleChange} required />
                                                </div>
                                                <button type="submit" className={updating ? "btn btn-netikash disabled w-px-150 h-px-50" : "btn btn-netikash w-px-150 h-px-50"}>
                                                    {updating ? (
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                                <span className="visually-hidden">Chargement...</span>
                                                            </div>
                                                        </div>
                                                    ) : "Enregistrer"}
                                                </button>
                                                <button type="button" className="btn btn-secondary ms-2 w-px-150 h-px-50" onClick={closeModal}>Annuler</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                );
                    break;
                    default:
                    componentToRender = null;
         }
      }
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 className="card-header">{title}</h5>
                {(type === "infos" || type === "options" || type === "subscriptionPlan") && (
                <>
                    {type === "options" && (
                        <Modal
                            title="Ajouter des Options à l'Application"
                            type="options"
                            btnTitle="Ajouter"
                            id="optionsModal"
                            btnStyle="normal"
                            enable={2}
                            nb={2}
                        />
                    )}
                    {type === "infos" && (
                        <Modal
                            title="Ajouter des Informations à l'Application"
                            type="info"
                            btnTitle="Ajouter"
                            id="infosModal"
                            btnStyle="normal"
                            enable={2}
                            nb={2}
                        />
                    )}
                    {type === "subscriptionPlan" && (
                        <Modal
                            title="Ajouter des Abonnements à l'Application"
                            type="subscriptionPlan"
                            btnTitle="Ajouter"
                            id="subscriptionsModal"
                            btnStyle="normal"
                            enable={2}
                            nb={2}
                        />
                    )}
                </>
                )}
                {type === "clientSubscription" && (
                    <input
                        className="form-control"
                        list="datalistOptions"
                        id="exampleDataList"
                        placeholder="Type to search..."
                        value={searchValue}
                        onChange={handleInputChange}
                        style={{
                            width: "100%",
                            marginLeft: "16px",
                        }}
                    />
                )}
                {type === "transactions" && (
                    <>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "16px" }}>

                            {charging && (
                                <ClipLoader color="#debf66" loading size={20}/>
                            )}
                            {/* Input de recherche */}
                            <input
                                className="form-control d-none d-md-block"
                                type="text"
                                placeholder="Filtrer par référence"
                                value={refValue}
                                onChange={handleInputChangeTrs}
                                style={{
                                    width: "200px"
                                }}
                            />

                            {/* Groupe de boutons radio pour la devise */}
                            <div className={"d-none d-md-block"}>

                                <div className="btn-group" role="group" aria-label="Devise">
                                    <input type="radio" className="btn-check" name="btnradioDevise" id="btnradioCDF" value="CDF"
                                           onChange={() => {
                                               setDevise("CDF")
                                               setCurrentPage(1)
                                           }}
                                           checked={devise === "CDF"}/>
                                    <label className="btn btn-outline-netikash" htmlFor="btnradioCDF">CDF</label>
                                    <input type="radio" className="btn-check" name="btnradioDevise" id="btnradioUSD" value="USD"
                                           onChange={() => {
                                               setDevise("USD");
                                               setCurrentPage(1)
                                           }}
                                           checked={devise === "USD"} />
                                    <label className="btn btn-outline-netikash" htmlFor="btnradioUSD">USD</label>
                                </div>

                            </div>

                            {/* Groupe de boutons radio pour le type de transaction */}
                            <div className={"d-none d-md-block"}>

                                <div className="btn-group" role="group" aria-label="Type de transaction">
                                    <input type="radio" className="btn-check" name="btnradioType" id="btnradioPayment" value="PMT"
                                           onChange={() => {
                                               setTransactionType("PMT");
                                               setCurrentPage(1)
                                           }}
                                           checked={transactionType === "PMT"}/>
                                    <label className="btn btn-outline-netikash" htmlFor="btnradioPayment">Paiement</label>
                                    <input type="radio" className="btn-check" name="btnradioType" id="btnradioWithdrawal" value="WDL"
                                           onChange={() => {
                                               setTransactionType("WDL");
                                               setCurrentPage(1)
                                           }}
                                           checked={transactionType === "WDL"}/>
                                    <label className="btn btn-outline-netikash" htmlFor="btnradioWithdrawal">Retrait</label>
                                </div>
                            </div>
                            <div className="d-block d-md-none mb-3">
                                <div className="dropdown">
                                    <button
                                        className="btn btn-netikash dropdown-toggle w-100"
                                        type="button"
                                        id="dropdownCombined"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Options
                                    </button>
                                    <ul className="dropdown-menu w-100" aria-labelledby="dropdownCombined">
                                        {/* Section Devise */}
                                        <li className="dropdown-header">Devise</li>
                                        <li>
                                            <button
                                                className={`dropdown-item d-flex align-items-center ${devise === "CDF" ? "text-netikash fw-bold" : ""}`}
                                                onClick={() => { setDevise("CDF"); setCurrentPage(1); }}
                                            >
                                                <i className="bx bx-chevron-right me-2"></i> CDF
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className={`dropdown-item d-flex align-items-center ${devise === "USD" ? "text-netikash fw-bold" : ""}`}
                                                onClick={() => { setDevise("USD"); setCurrentPage(1); }}
                                            >
                                                <i className="bx bx-chevron-right me-2"></i> USD
                                            </button>
                                        </li>

                                        <li><hr className="dropdown-divider" /></li>

                                        {/* Section Type de transaction */}
                                        <li className="dropdown-header">Type de transaction</li>
                                        <li>
                                            <button
                                                className={`dropdown-item d-flex align-items-center ${transactionType === "PMT" ? "text-netikash fw-bold" : ""}`}
                                                onClick={() => { setTransactionType("PMT"); setCurrentPage(1); }}
                                            >
                                                <i className="bx bx-chevron-right me-2"></i> Paiement
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className={`dropdown-item d-flex align-items-center ${transactionType === "WLD" ? "text-netikash fw-bold" : ""}`}
                                                onClick={() => { setTransactionType("WLD"); setCurrentPage(1); }}
                                            >
                                                <i className="bx bx-chevron-right me-2"></i> Retrait
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>



                        </div>
                    </>
                )}

            </div>
            <div className="table-responsive text-nowrap">
                {componentToRender}
            </div>

            {type === "transactions" && transactions.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                        className="btn btn-outline-netikash d-flex align-items-center"
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1} // désactiver le bouton si c'est la 1ère page
                    >
                        <i className="bx bx-chevron-left me-2"></i> Précédent
                    </button>

                    {/* Texte pour afficher le numéro de page */}
                    <span className="fw-bold text-muted">
                        Page {currentPage}
                    </span>

                    <button
                        className="btn btn-outline-netikash d-flex align-items-center"
                        onClick={handleNextPage}
                        disabled={isLastPage} // désactiver si c'est la dernière page
                    >
                        Suivant <i className="bx bx-chevron-right ms-2"></i>
                    </button>
                </div>
            )}


        </div>
    );
}